import * as React from 'react';

import { inject, observer } from 'mobx-react';
import { LocalizedText } from 'bernie-l10n';

import { UitkIcon } from 'uitk-react-icons';
import { UitkLoader } from 'uitk-react-loader';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { PropertyReviewType } from '__generated__/api/types';
import { MoreReviewsButton, ReviewCardOnDialog } from 'components/common/reviews/review-components';

export interface ReviewsListOnDialogProps {
  reviewsType?: PropertyReviewType;
  onMoreReviews: () => void;
  currentHotel?: CurrentHotelStore;
  areTabsPresent?: boolean;
  hideTopPadding?: boolean;
}

@inject('currentHotel')
@observer
export class ReviewsListOnDialog extends React.Component<ReviewsListOnDialogProps> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { reviewsType, onMoreReviews, currentHotel, areTabsPresent, hideTopPadding } = this.props;
    const filtersApplied = currentHotel && currentHotel.checkReviewsFiltersApplied;
    const reviewsByType = {};
    reviewsByType[PropertyReviewType.POSITIVE] = currentHotel.positiveReviews;
    reviewsByType[PropertyReviewType.CRITICAL] = currentHotel.criticalReviews;

    let reviews;
    if (filtersApplied) {
      reviews = currentHotel.filteredReviews;
    } else {
      reviews = reviewsByType[reviewsType] || currentHotel.reviews;
    }

    if (reviews.count === null) {
      return (
        <div className="uitk-grid all-grid-align-center all-x-gutter-three">
          <UitkLoader />
        </div>
      );
    }

    if (reviews.userReviews && reviews.userReviews.length > 0) {
      return (
        <>
          <section className="review-cards">
            {reviews.userReviews.map((review, index) => (
              <ReviewCardOnDialog
                review={review}
                key={review.reviewId}
                index={index}
                areTabsPresent={areTabsPresent}
                hideTopPadding={hideTopPadding}
              />
            ))}
          </section>
          {this.moreReviewsAvailable(reviews) && <MoreReviewsButton onMoreReviews={onMoreReviews} rfrrId="Reviews.ClickMoreReviews" />}
        </>
      );
    }

    return (
      <section className="uitk-type-200 pwa-theme--grey-700 uitk-type-center" data-stid="no-reviews">
        <UitkIcon name="warning" />
        <p>
          <LocalizedText message="hotels.infosite.reviews.noReviews.text" />
        </p>
      </section>
    );
  }

  private moreReviewsAvailable(reviews) {
    const { reviewsType } = this.props;

    if (reviewsType) {
      return reviews && reviews.lastIndex < reviews.count && !reviews.fetchedEmptyReviews;
    }

    return (
      reviews.userReviews.length < reviews.count &&
      reviews.userReviews.length === reviews.totalReviewsRequested &&
      !reviews.fetchedEmptyReviews
    );
  }
}
